import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean, dropModulos, dropParcelas } from 'utils/drops';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import InputMask from 'components/InputMask';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'CondicaoDePagamento';
  const defaultValues = {
    descricao: '',
    modulo: null,

    custofin: '',
    nvezes: '',
    dia: '',
    entrada: null,

    intervalop: '',
    intervalo: '',

    forasemana: null,
    foraquinzena: null,
    forames: null,

    imposto: null,
    frete: null,

    caixa: null,
    ativo: null,
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { drops, getDrops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => {
        navigate(-1);
        getDrops(['CondicaoPagamento']);
      },
    });

  return (
    <Container>
      <Header
        titulo={
          (Boolean(state) ? 'Editar' : 'Cadastrar') + ' Condição de Pagamento'
        }
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Input name="descricao" control={control} label="Descrição" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="modulo"
              control={control}
              label="Módulo"
              options={dropModulos}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask
              name="custofin"
              control={control}
              label="% Custo Financeiro"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="nvezes" control={control} label="Nº de Vezes" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="dia" control={control} label="Dia Fixo" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask
              name="intervalop"
              control={control}
              label="Intervalo da 1ª Parcela"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask
              name="intervalo"
              control={control}
              label="Intervalo das Demais Parcelas"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="entrada"
              control={control}
              label="Entrada"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="forasemana"
              control={control}
              label="Fora Semana"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="foraquinzena"
              control={control}
              label="Fora Quinzena"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="forames"
              control={control}
              label="Fora Mês"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="imposto"
              control={control}
              label="Parcela do Imposto"
              options={dropParcelas}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="frete"
              control={control}
              label="Parcela do Frete"
              options={dropParcelas}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="caixa"
              control={control}
              label="Caixa"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="ativo"
              control={control}
              label="Ativo"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
